import { useState } from "react";
import PredefinedReasonBan from "./PredefinedReasonBan";
import ModalWindow from "../../../../../../../../../Components/ModalWindow/ModalWindow";
import { AddToastNotification } from "../../../../../../../../../Services/ToastNotification/ToastNotificationManager";

const PredefinedReason = ({ getOnlinePlayers, getOfflinePlayers, executeBan}) => {

    const [modalVisible, setModalVisible] = useState();
    const [predefinedReason, setPredefinedReason] = useState();

    const onlinePlayerCount = getOnlinePlayers().length;
    const offlinePlayerCount = getOfflinePlayers().length;

    const openModal = (ban) => {
        if(onlinePlayerCount > 0 || offlinePlayerCount > 0){
            setPredefinedReason(ban);
            setModalVisible(true)
        }else{
            AddToastNotification("Musisz wybrać graczy do zbanowania!", 0)
        }
    }

    return (
        <div className="mt-4 h-[85%] overflow-auto">
            { window.scpsl_predefinedReason.map(reason => 
                <PredefinedReasonBan predefinedReason={reason} onClick={openModal}/>
            )}
            { modalVisible &&
                <ModalWindow 
                    title={"Ban player/s"}
                    content={
                        <div>
                            <p>Czy na pewno chcesz zbanować graczy za <span className="text-glred">{predefinedReason.reason}</span>?</p>
                            
                            { onlinePlayerCount > 0 &&
                                <p>Ilość graczy online do zbanowania: <span className="text-glred">{onlinePlayerCount}</span></p>
                            }
                            { offlinePlayerCount > 0 &&
                                <p>Ilość graczy offline do zbanowania: <span className="text-glred">{offlinePlayerCount}</span></p>
                            }
                        </div>
                    }
                    buttons={[
                        { Text: "Tak", onClick: () => { executeBan(predefinedReason.time, predefinedReason.reason, () => {setModalVisible(false)}) }},
                        { Text: "Nie", className: "modalSecondaryBtn", onClick: () => { setModalVisible(false) }}
                    ]}
                />
            }
        </div>
    )
}

export default PredefinedReason;